import {RootState} from "../../../store";
import {createSelector} from "@reduxjs/toolkit";

const selectCompaniesState = (state: RootState) => state.companies;

export const selectCompanies = createSelector([selectCompaniesState], (companiesState) => companiesState.list);

export const selectCompaniesOptions = createSelector([selectCompaniesState],
    (companiesState) => companiesState.list.map(companies => ({
        id: companies.id,
        title: `${companies.name} ${companies.owner_email} ${companies.INN}`,
    })));

export const selectCurrentCompany = createSelector([selectCompaniesState], (companiesState) => companiesState.current);

export const selectCompanyIsLoading = createSelector(
    [selectCompaniesState],
    (companiesState) => companiesState.isLoading,
);

export const selectCurrentCompanyName = createSelector([selectCompaniesState], (companiesState) =>
    companiesState.current ? companiesState.current.name : null,
);

const selectBalanceHistory = createSelector(
    [selectCompaniesState],
    (s) => s.balanceHistory,
);
export const selectBalanceHistoryItems = createSelector(
    [selectBalanceHistory],
    (h) => h.items,
);
export const selectBalanceHistoryIsLoading = createSelector(
    [selectBalanceHistory],
    (h) => h.isLoading,
);
export const selectBalanceHistoryPagination = createSelector(
    [selectBalanceHistory],
    ({total, page, limit, pages}) => ({total, page, limit, pages}),
);

export const selectBalanceHistoryHasMore = createSelector(
    [selectBalanceHistory],
    (h) => h.hasMore,
);

export const selectPaymentIsCreating = (state: RootState) =>
    state.companies.payment.isCreating;

export const selectLastPayment = (state: RootState) =>
    state.companies.payment.lastPayment;

export const selectPaymentError = (state: RootState) =>
    state.companies.payment.error;

export const selectCompanyTariff = (state: RootState) =>
    state.companies.current?.companyTariff ?? null;

// true если тариф называется "pro" (регистронезависимо)
export const selectIsTariffPro = (state: RootState) => {
    const name = state.companies.current?.companyTariff?.tariff?.name;
    return name?.toLowerCase() === 'pro';
};
// false если balance.is_enabled = false (просроченная оплата)
export const selectIsAccountEnabled = (state: RootState) =>
    state.companies.current?.balance?.is_enabled ?? true;

export const selectCompanyTariffName = (state: RootState): string | null =>
    state.companies.current?.companyTariff?.tariff?.name?.toLowerCase() ?? null;

export const selectBalanceInfo = (state: RootState) => state.companies.balanceInfo;
export const selectBalanceInfoLoading = (state: RootState) => state.companies.balanceInfoLoading;